<section class="main-wrap inner-views">
  <div class="container-wrap">
    <div class="sidebar-container sc-empty">
      <app-sidebar-empty></app-sidebar-empty>
    </div>
    <div class="content-container login-container">
      <div class="row">
        <div class="col-md-12">
          <h1>Welcome to Eyelation</h1>
          <p class="subtitle">Sign Up</p>
          <div class="form-wrap">
            <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
              <div class="formField firstName">
                <label for="firstName">First Name</label>
                <input
                  id="firstName"
                  class="form-control"
                  formControlName="firstName"
                  placeholder="First Name"
                  type="text"
                  [ngClass]="{
                    'is-invalid':
                      (sfc.firstName.dirty || sfc.firstName.touched) &&
                      sfc.firstName.errors
                  }"
                  />
                @if (
                  (sfc.firstName.dirty || sfc.firstName.touched) &&
                  sfc.firstName.errors
                  ) {
                  <div
                    class="invalid-feedback"
                    [ngClass]="{ 'd-block': sfc.firstName.errors }"
                    >
                    First Name is required.
                  </div>
                }
              </div>
              <div class="formField lastName">
                <label for="lastName">Last Name</label>
                <input
                  id="lastName"
                  class="form-control"
                  formControlName="lastName"
                  placeholder="Last Name"
                  type="text"
                  [ngClass]="{
                    'is-invalid':
                      (sfc.lastName.dirty || sfc.lastName.touched) &&
                      sfc.lastName.errors
                  }"
                  />
                @if (
                  (sfc.lastName.dirty || sfc.lastName.touched) &&
                  sfc.lastName.errors
                  ) {
                  <div
                    class="invalid-feedback"
                    [ngClass]="{ 'd-block': sfc.lastName.errors }"
                    >
                    Last Name is required.
                  </div>
                }
              </div>
              <div class="formField userinput">
                <label for="emailAddress">Email</label>
                <input
                  id="emailAddress"
                  class="form-control"
                  formControlName="emailAddress"
                  placeholder="Enter Email"
                  type="text"
                  [ngClass]="{
                    'is-invalid':
                      (sfc.emailAddress.dirty || sfc.emailAddress.touched) &&
                      sfc.emailAddress.errors
                  }"
                  />
                @if (
                  (sfc.emailAddress.dirty || sfc.emailAddress.touched) &&
                  sfc.emailAddress.errors?.required
                  ) {
                  <div
                    class="invalid-feedback"
                    [ngClass]="{ 'd-block': sfc.emailAddress.errors }"
                    >
                    Email is required.
                  </div>
                }
                @if (
                  (sfc.emailAddress.dirty || sfc.emailAddress.touched) &&
                  sfc.emailAddress.errors?.email
                  ) {
                  <div
                    class="invalid-feedback"
                    [ngClass]="{ 'd-block': sfc.emailAddress.errors }"
                    >
                    Email is invalid.
                  </div>
                }
              </div>
              <div class="formField passInput notLast">
                <label for="userPass">Password</label>
                <div class="position-relative">
                  <input
                    id="userPass"
                    class="form-control"
                    formControlName="newPassword"
                    placeholder="Enter a Password"
                    [type]="showPassword ? 'text' : 'password'"
                    [ngClass]="{
                      'is-invalid':
                        (sfc.newPassword.dirty || sfc.newPassword.touched) &&
                        sfc.newPassword.errors
                    }"
                    />
                  <toggle-password-button
                    [showPassword]="showPassword"
                    (onIconClick)="onTogglePasswordButtonClick()"
                    tabindex="-1"
                  ></toggle-password-button>
                </div>
                @if (
                  (sfc.newPassword.dirty || sfc.newPassword.touched) &&
                  sfc.newPassword.errors?.required
                  ) {
                  <div
                    class="invalid-feedback"
                    [ngClass]="{ 'd-block': sfc.newPassword.errors }"
                    >
                    Password is required.
                  </div>
                }
              </div>
              <div class="formField passInput">
                <label for="userPassConfirm">Confirm Password</label>
                <div class="position-relative">
                  <input
                    id="userPassConfirm"
                    class="form-control"
                    formControlName="confirmPassword"
                    placeholder="Re-enter Your Password"
                    [type]="showConfirmPassword ? 'text' : 'password'"
                    [ngClass]="{
                      'is-invalid':
                        (sfc.confirmPassword.dirty ||
                          sfc.confirmPassword.touched) &&
                        sfc.confirmPassword.errors
                    }"
                    />
                  <toggle-password-button
                    [showPassword]="showConfirmPassword"
                    (onIconClick)="onToggleConfirmPasswordButtonClick()"
                    tabindex="-1"
                  ></toggle-password-button>
                </div>
                @if (
                  (sfc.confirmPassword.dirty ||
                  sfc.confirmPassword.touched) &&
                  sfc.confirmPassword.errors?.required
                  ) {
                  <div
                    class="invalid-feedback"
                  [ngClass]="{
                    'd-block': sfc.confirmPassword.errors?.required
                  }"
                    >
                    Confirm password is required.
                  </div>
                }
                @if (
                  (sfc.confirmPassword.dirty ||
                  sfc.confirmPassword.touched) &&
                  sfc.confirmPassword.errors?.mustMatch
                  ) {
                  <div
                    class="invalid-feedback"
                  [ngClass]="{
                    'd-block': sfc.confirmPassword.errors?.mustMatch
                  }"
                    >
                    Re-enter password does not match.
                  </div>
                }
              </div>
              <div class="passReqsContainer">
                <h5 class="passReqsContainer__title">Password must contain</h5>
                <ul class="passReqsContainer__menuItem menuItem">
                  @for (rule of passwordRules; track $index) {
                    <div
                      class="menuItem__item"
                      >
                      <img
                        alt="Task icon"
                        [src]="rule.icon"
                        width="20"
                        height="20"
                        />
                      <li [ngClass]="{ hightlight: rule.isHighlight }">
                        {{ rule.content }}
                      </li>
                    </div>
                  }
                </ul>
              </div>
              <div class="formField submitInput">
                <input
                  id="signUp"
                  type="submit"
                  class="btn gray-btn"
                  value="Sign Up"
                  />
              </div>
              <p>
                Already have an account?
                <a [routerLink]="['../login']"><strong>Log In</strong></a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
